import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LegendChoropleth from './legend-choropleth';
import LegendTitle from './legend-title';
import classnames from 'classnames';

import './style.css';

class Legend extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  onToggleCollapse = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen })
  }

  render() {
    const { pollutant, items, type } = this.props;
    const { isOpen } = this.state;
    return (
      <div className="c-legend">
        <div className={classnames({
          'legend-info': true,
          '-opened': isOpen
        })}>
          <LegendTitle pollutant={pollutant} legendValues={items}/>

          {type === 'choropleth' && items && <LegendChoropleth items={items}/>}
        </div>
        <button
          type="button"
          className={classnames({
            'legend': true,
            '-opened': isOpen
          })}
          onClick={this.onToggleCollapse}>
          <span>{isOpen ? 'Collapse' : 'Legend'}</span>
        </button>
      </div>)
  }


}
Legend.propTypes = {
  type: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  pollutant: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string
  })
};

Legend.defaultProps = {
  type: 'choropleth',
  pollutant: {}
};

export default Legend;



// WEBPACK FOOTER //
// ./src/components/legend/component.js